import { ADD_TOOLTIP } from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { SecondaryFilter } from "@/modules/Dashboards/AdminDashboard/models/SecondaryFilter";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ObjFilterList } from "../../model/List";
import { PreventKey } from "@/shared/mixins/mixins";
import { PORCENTAJE_OPERATORS_OBJ } from "@/shared/constants/GeneralConstants";
import { EVENT_EMITTER } from "../../constants/GenericSearchConstants";

@Component({
  name: "FilterTypeRange"
})
export default class FilterTypeRange extends Vue {
  @Prop({ default: () => false }) isPrincipal!: boolean;
  @Prop() itemFilter!: SecondaryFilter;
  @Prop() private selectFilter!: ObjFilterList[];

  preventKey = PreventKey;
  ADD_TOOLTIP = ADD_TOOLTIP;
  btnClassTertiary = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  progressRange = [0, 100];
  minProgress = 0;
  maxProgress = 100;

  clearData = 0;
  beforeMount() {
    this.initFilter();
  }

  reload() {
    this.clearData = 1 - this.clearData;
  }

  get selectFilterLocal() {
    return this.selectFilter;
  }

  set selectFilterLocal(filterSelected: ObjFilterList[]) {
    this.$emit(EVENT_EMITTER.UPDATE_SELECT_FILTER, filterSelected);
  }

  getObjFilterList(operation: { name: string; key: string }, value: number) {
    return {
      key: value.toString(),
      name: operation.name + " " + value,
      operation: operation.key
    };
  }

  @Watch("progressRange")
  rango() {
    const selectFilter: ObjFilterList[] = [];
    if (this.progressRange[0] > this.minProgress) {
      selectFilter.push(
        this.getObjFilterList(
          PORCENTAJE_OPERATORS_OBJ.GREATER_THAN,
          this.progressRange[0]
        )
      );
    }
    if (this.progressRange[1] < this.maxProgress) {
      selectFilter.push(
        this.getObjFilterList(
          PORCENTAJE_OPERATORS_OBJ.LESS_THAN,
          this.progressRange[1]
        )
      );
    }

    this.selectFilterLocal = selectFilter;
  }

  @Watch("selectFilter")
  initFilter() {
    const progressRange = [0, 100];
    this.selectFilter?.forEach(filter => {
      switch (filter.operation) {
        case PORCENTAJE_OPERATORS_OBJ.GREATER_THAN.key:
          progressRange[0] = Number(filter.key);
          break;
        case PORCENTAJE_OPERATORS_OBJ.LESS_THAN.key:
          progressRange[1] = Number(filter.key);
          break;
      }
    });

    if (
      this.progressRange[0] != progressRange[0] ||
      this.progressRange[1] != progressRange[1]
    ) {
      this.progressRange = progressRange;
    }

    this.reload();
  }
}
